import { Link } from "react-router-dom";
import { useEmployerDashboard } from "@/hooks/use-hr-queries";
import { Page, QueryGate, Stat } from "@/components/shell/page";
import { formatDateDisplay } from "@/lib/timezone";

export default function EmployerDashboardPage() {
  const { data, isLoading, error } = useEmployerDashboard();
  const employees = data?.employees ?? {};

  return (
    <QueryGate loading={isLoading} error={error || !data ? "Could not load the workforce view." : null}>
      {data && (
        <Page
          title="Today"
          description={formatDateDisplay(data.date)}
          actions={
            <Link
              to="/employer/leave"
              className="inline-flex min-h-11 cursor-pointer items-center rounded-lg bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              Review leave
            </Link>
          }
        >
          <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
            <Stat label="Employees" value={employees.total ?? 0} hint={`${employees.active ?? 0} active`} />
            <Stat label="On leave today" value={employees.on_leave_today ?? 0} />
            <Stat
              label="Leave waiting"
              value={data.leave?.pending ?? 0}
              attention={(data.leave?.pending ?? 0) > 0}
            />
            <Stat
              label="Overdue tasks"
              value={employees.overdue_tasks ?? 0}
              attention={(employees.overdue_tasks ?? 0) > 0}
            />
            <Stat label="Open tasks" value={employees.pending_tasks ?? 0} />
            <Stat label="Missing reports" value={employees.missing_reports ?? 0} />
            <Stat label="Missing hours" value={employees.missing_timesheets ?? 0} />
          </div>
        </Page>
      )}
    </QueryGate>
  );
}
